import {useNavigate} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {RecoverPasswordPage} from "@/pages/auth/RecoverPassword";

const RecoverPasswordRoute = () => {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-[var(--color-bg)] px-4 py-8">
      <RecoverPasswordPage onBack={() => navigate(PATHS.home, {replace: true})} />
    </main>
  );
};

export default RecoverPasswordRoute;
